module.exports = __webpack_public_path__ + "static/media/B11.2d1a972a.jpg";